let newVal = {};

export const setSessionStorage = (key, value) => {
  newVal.value = value;
  sessionStorage.setItem(key, JSON.stringify(newVal));
}

export const getSessionStorage = (key) => {
  const value = sessionStorage.getItem(key);
  if(value) {
    return JSON.parse(value).value
  }
  return value;
}


// WEBPACK FOOTER //
// ./src/untils/storage/index.js